<template>
  <div
    class="nav-container"
    :class="{
      isMobile: isMobile,
      sticky: alwaysStickyHeader,
    }"
    ref="navContainer"
  >
    <v-img class="header-logo" :src="determineSrc" />
    <v-app-bar
      flat
      :color="'white'"
      class="meme"
      v-if="!isSticky"
      v-show="!isMobile"
    >
    </v-app-bar>
    <div style="background-color: white" v-if="isMobile && !isSticky"></div>
    <NavDrawer
      v-if="!isSticky"
      :windowWidth="this.windowWidth"
      :isSticky="isSticky"
    />
    <div
      v-if="!isMobile"
      class="horizontal-menu"
      :class="{
        'elevation-11': isSticky,
      }"
    >
      <template>
        <router-link
          v-for="(item, index) in loggedOutItems"
          class="menu-btn"
          :ripple="false"
          :href="item.href"
          :to="!!item.to ? item.to : item.href"
          :target="item.target"
          :key="index"
          exact
        >
          {{ item.title }}
        </router-link>
      </template>
      <template>
        <div class="menu-button-container">
          <AccessButton
            class="login-btn"
            :buttonText="'Login'"
            @accessButtonClicked="loginClicked"
            v-if="!isLogin && !isAdviserEnrolment && !isHome1Route"
          />
          <AccessButton
            class="signup-btn"
            :buttonText="'Create Will'"
            @accessButtonClicked="signup"
            v-if="
              !isRegister && !isAdviserEnrolment && whitelabel.brand !== 'teba'
            "
          />
        </div>
      </template>
    </div>
    <div
      v-else-if="isMobile && isSticky"
      class="horizontal-menu-mobile"
      :class="{ 'elevation-11': isSticky }"
    >
      <NavDrawer :isSticky="isSticky" :windowWidth="windowWidth" />
      <template>
        <div class="menu-button-container isMobile">
          <AccessButton
            class="login-btn"
            :buttonText="'Login'"
            @accessButtonClicked="loginClicked"
            v-if="!isLogin && !isAdviserEnrolment && !isHome1Route"
          />
          <AccessButton
            class="signup-btn"
            :buttonText="'Create Will'"
            @accessButtonClicked="signup"
            v-if="
              !isRegister && !isAdviserEnrolment && whitelabel.brand !== 'teba'
            "
          />
        </div>
      </template>
    </div>
    <div
      v-if="isMobile && !isPad && !isSticky"
      class="horizontal-menu isMobile"
      :class="{ 'elevation-11': isSticky }"
    >
      <template>
        <div class="menu-button-container isMobile">
          <AccessButton
            class="login-btn"
            :buttonText="'Login'"
            @accessButtonClicked="loginClicked"
            v-if="!isLogin && !isAdviserEnrolment && !isHome1Route"
          />
          <AccessButton
            class="signup-btn"
            :buttonText="'Create Will'"
            @accessButtonClicked="signup"
            v-if="
              !isRegister && !isAdviserEnrolment && whitelabel.brand !== 'teba'
            "
          />
        </div>
      </template>
    </div>
    <div
      v-if="isPad && !isSticky"
      class="horizontal-menu isPad"
      :class="{ 'elevation-11': isSticky }"
    >
      <AccessButton
        class="login-btn"
        :buttonText="'Login'"
        @accessButtonClicked="loginClicked"
        v-if="!isLogin && !isAdviserEnrolment"
      />
      <AccessButton
        class="signup-btn"
        :buttonText="'Create Will'"
        @accessButtonClicked="signup"
        v-if="!isRegister && !isAdviserEnrolment && whitelabel.brand !== 'teba'"
      />
    </div>
  </div>
</template>

<script>
  import { mdiLock, mdiMagnify } from '@mdi/js';
  import NavDrawer from './NavDrawer.vue';
  import { adviserEnrolmentRouteNames } from '@/helpers/routes/route-helper';
  import { mapGetters } from 'vuex';
  import AccessButton from '../common/AccessButton.vue';

  export default {
    name: 'NavBarAlternative',
    components: {
      NavDrawer,
      AccessButton,
    },
    data() {
      return {
        isSticky: false,
        threshold: this.isMobile ? 11 : 147,
        debounceTimeout: null,
        windowWidth: window.innerWidth,
        icons: {
          mdiLock: mdiLock,
          mdiMagnify: mdiMagnify,
        },
        isLandingSimple: false,
      };
    },
    created() {
      const landingState = localStorage.getItem('isLandingSimple');
      this.isLandingSimple = landingState ? true : false;
      if (
        (this.isMobile && this.alwaysStickyHeader) ||
        (!this.isMobile && this.alwaysStickyHeader)
      ) {
        this.threshold = -1;
        this.isSticky = true;
      }
    },
    computed: {
      ...mapGetters(['coBrandCompanyUrl']),
      ...mapGetters(['coBrandCompanyName']),
      loggedOutItems() {
        return [
          {
            title: 'Home',
            to: this.isLandingSimple ? '/getstarted' : '/',
          },
          {
            title: 'How it works',
            to: '/how-it-works',
          },
          {
            title: 'Our Solutions',
            to: '/our-solutions',
          },
          {
            title: 'Calculators',
            to: '/calculators',
          },
          {
            title: 'FAQs',
            to: '/faqs',
          },
          {
            title: 'Articles',
            to: '/articles',
          },
        ];
      },
      isMobile() {
        return this.$isMobileDevice() || this.windowWidth <= 1080;
      },
      isPad() {
        return this.$isPad();
      },
      determineSrc() {
        if (this.coBrandCompanyUrl) {
          return this.coBrandCompanyUrl;
        } else
          return require('@/assets/shared/redesign/hero-bar/om-logo-header.svg');
      },
      isArticle() {
        return this.$route.name === 'Article';
      },
      alwaysStickyHeader() {
        return this.isPageNotFound || this.isRegister || this.isLogin;
      },
      isPageNotFound() {
        return this.$route.name === 'PageNotFound';
      },
      isRegister() {
        return this.$route.name === 'Register';
      },
      isLogin() {
        return this.$route.name === 'Login';
      },
      isAdviserEnrolment() {
        return adviserEnrolmentRouteNames.includes(this.$route.name);
      },
      isHome1Route() {
        return (
          this.$route.path.includes('/create-your-will') ||
          this.$route.path.includes('/your-free-will') ||
          this.$route.path.includes('/free-will-template') ||
          this.$route.path.includes('/vodacom-competition')
        );
      },
    },
    methods: {
      loginClicked() {
        this.$router.push('/Login');
      },
      signup() {
        this.$router.push('/register');
      },
      handleScroll() {
        if (this.debounceTimeout) {
          clearTimeout(this.debounceTimeout);
        }
        const navContainer = this.$refs.navContainer;
        const scrollTop = window.scrollY;

        this.debounceTimeout = setTimeout(() => {
          if (scrollTop > this.threshold && !this.isSticky) {
            this.isSticky = true;
            navContainer.style.transition = 'none';
            navContainer.style.top = `-${navContainer.offsetHeight}px`;
            navContainer.style.height = `${navContainer.offsetHeight}px`;
            // Force reflow
            navContainer.offsetHeight;
            requestAnimationFrame(() => {
              navContainer.style.transition =
                'top .666s ease, height .666s ease';
              navContainer.classList.add('sticky');
              navContainer.style.top = '0';
              navContainer.style.height = 'auto';
            });
          } else if (scrollTop <= this.threshold && this.isSticky) {
            this.isSticky = false;
            navContainer.style.transition = 'none';
            navContainer.style.top = '0';
            navContainer.style.height = `${navContainer.offsetHeight}px`;
            // Force reflow
            navContainer.offsetHeight;
            requestAnimationFrame(() => {
              navContainer.style.transition =
                'top .666s ease, height .666s ease';
              navContainer.classList.remove('sticky');
              navContainer.style.height = 'auto';
            });
          }
        }, 10);
      },
      handleWidth() {
        this.windowWidth = window.innerWidth;
      },
    },
    mounted() {
      window.addEventListener('resize', this.handleWidth);
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.addEventListener('resize', this.handleWidth);
      window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
      $route() {
        if (!this.alwaysStickyHeader) {
          this.threshold = this.isMobile ? 11 : 147;
          this.isSticky = false;
        } else {
          this.threshold = -1;
          this.isSticky = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../constants/styles/mixins.scss';

  .partnered-with {
    background-color: var(--v-primary-base);
    color: #ffffff;

    .partnered-with-text {
      margin-top: 2px;
      margin-bottom: 2px;
    }
  }

  .nav-container {
    position: relative;
    min-height: 40px;
    z-index: 1000;
    width: 100%;
    .header-logo {
      position: absolute;
      left: 32px;
      width: 60px;
      z-index: 11;
    }
    .horizontal-menu {
      position: absolute;
      top: 75px;
      left: 145px;
      width: calc(100% - 145px);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      z-index: 10;
      gap: 25px;
      &.isArticle {
        top: 37px;
      }

      &.isMobile {
        left: 0;
        top: 25px;
        padding: 10px 0;
        align-items: center;
        justify-content: flex-end !important;
        width: 100%;

        .login-btn,
        .signup-btn {
          margin: 0 !important;
          button {
            background-color: white;
            border-color: #ccc;
          }
        }
      }

      &.isPad {
        left: 0;
        top: 28px;
        padding: 10px 0;
        align-items: center;
        justify-content: flex-end !important;
        width: 100%;

        .login-btn,
        .signup-btn {
          margin: 0 !important;
          button {
            background-color: white;
            border-color: #ccc;
          }
        }
      }

      a:not(.login-btn, .signup-btn) {
        text-decoration: none;
        color: white !important;
        font-feature-settings: 'clig' off, 'liga' off;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0.1px;
        &.router-link-active {
          -webkit-text-stroke: 1px white;
        }
        &:hover {
          -webkit-text-stroke: 1px white;
        }
      }
      .login-btn,
      .signup-btn {
        button {
          background-color: white;
          border-color: #ccc;
        }
      }
    }
    .horizontal-menu.co-branded {
      top: auto;
    }

    &.nav-container.sticky {
      position: fixed;
      top: 0 !important;
      width: 100%;
      -webkit-transition: top 1s ease;
      -moz-transition: top 1s ease;
      -o-transition: top 1s ease;
      transition: top 1s ease;
      will-change: top;
      .header-logo {
        position: absolute;
        left: 32px;
        top: -20px;
        width: 60px;
        z-index: 11;
        height: 102px;
      }
      .horizontal-menu {
        width: 100%;
        height: 71px;
        left: 0;
        top: 0;
        background-color: white;
        justify-content: flex-start;
        align-items: center;
        padding-left: 145px;
        transition: background-color 0.333s ease;
        a:not(.login-btn, .signup-btn) {
          color: black !important;
          &.router-link-active,
          &:hover {
            -webkit-text-stroke: 1px black;
          }
        }
      }
      &.isMobile {
        .header-logo {
          position: absolute;
          left: 12px;
          top: -20px;
          width: 60px;
          z-index: 11;
        }
        .horizontal-menu-mobile {
          display: flex;
          width: 100%;
          height: 71px;
          background-color: white;
          justify-content: flex-end;
          align-items: center;
          transition: background-color 0.333s ease;
          .login-btn,
          .signup-btn {
            margin-left: auto;
            button {
              background-color: white;
              border-color: #ccc;
              color: black;
            }
          }
        }
      }
    }
    .menu-btn {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }
  .menu-button-container {
    display: flex;
    margin-left: auto;
    padding-right: 40px;
    gap: 5px;
    &.isMobile {
      padding-right: 0;
    }
  }
  @media only screen and (orientation: landscape) and (max-width: 932px) {
    .nav-container {
      height: 0;
      min-height: 0;
    }
  }
  @media screen and (max-width: 1057px) {
    .nav-container {
      height: 0;
      min-height: 0;
      .header-logo {
        left: 15px;
      }
    }
    .nav-drawer-button-container {
      top: 11px;
      left: 100px;
    }
    .custom-delimiter {
      bottom: 0;
    }
  }
</style>
